import React from "react";

import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { Box, Stack } from "@mui/material";
import ReactHtmlParser, { DOMNode, Element, Text } from "html-react-parser";
import { DocumentSectionWebSearch } from "store/types";

import { AIQuestionText } from "../AI-question-text/AIQuestionText";

interface WebSearchSectionProps {
  section: DocumentSectionWebSearch;
}

export const WebSearchSection = ({ section }: WebSearchSectionProps) => {
  const parseOptions = {
    replace: (domNode: DOMNode) => {
      if (domNode instanceof Element && domNode.name === "a" && domNode.attribs?.class?.includes("link-ref")) {
        return (
          <>
            <a
              href={domNode.attribs.href}
              className={domNode.attribs.class}
              target={domNode.attribs.target}
              rel={domNode.attribs.rel}
              style={{
                color: "#0A3142",
                textDecoration: "none"
                // verticalAlign: "middle"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
            >
              {domNode.children?.map((child: DOMNode) => {
                if (child instanceof Text) {
                  return child.data;
                }
                return ReactHtmlParser(child.toString());
              })}
            </a>
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#DBE8F5",
                width: "24px",
                height: "18px",
                borderRadius: "4px",
                ml: "4px",
                verticalAlign: "middle"
              }}
            >
              <OpenInNewOutlinedIcon sx={{ fontSize: "16px", fill: "#496682" }} />
            </Box>
          </>
        );
      }
    }
  };

  return (
    <Stack gap="10px">
      {section.parameters?.question && <AIQuestionText question={section.parameters?.question} />}
      <Stack sx={{ color: "#0A3142" }}>{section.text && ReactHtmlParser(section.text, parseOptions)}</Stack>
    </Stack>
  );
};
